import URL from 'url';
import UserAgent from 'helpers/device';
import {redirectTo} from 'helpers/redirect';
import FetchWrapper from 'helpers/fetch-wrapper';
import SimplexLineup from 'models/simplex-lineup';
import Const from 'constants';
import API from 'api';
import {showPopup} from 'helpers/modal';
import getLineupResolver from 'services/lineup-resolver/factory';
import {createLineupsStorage} from 'storages/lineups-storage';
import {getSettingsService, getPlayerService, getLpService} from 'services/sports/factory';
import {isLineupValid} from 'helpers/lineup-helper';

function isThereLineupToReoptimize(state) {
    const {
        sportConfig,
        lineupsData: {rawLineups},
        lineupsQuantity,
    } = state;

    if (!sportConfig.isModeLateswap()) {
        return false;
    }

    const currentLineupNumber = 1 + rawLineups.getQuantity();

    return currentLineupNumber < lineupsQuantity.getLineupsQuantity();
}

let LPWorker = null;
let totalLpSolveExecutionTimeInSeconds = 0;

// Built from webpack's publicPath so the worker resolves under the app's base
// path ('/lineup-tool/'), the same origin-absolute prefix the bundles use.
const LP_WORKER_URL = `${__webpack_public_path__}js/optimizer.min.js`;

let LineupResolver = {
    setResolvingProcessData(data) {
        return {
            type: Const.SET_LINEUP_RESOLVING_PROCESS_DATA,
            data,
        };
    },
    beforeOptimization() {
        return (dispatch, getState) => {
            dispatch(this.unsetLineups());
            dispatch(this.resetLineupPlayerFilter());
            dispatch(this.setStatusOfLineupsIsFilled(false));
            dispatch(this.unsetRawLineups());
            dispatch(this.unsetRandomPoints());
            dispatch(this.createOptimizationConfig());

            dispatch({
                type: Const.GET_LINEUPS_REQUEST,
            });

            getSettingsService(getState().sportConfig).exec('saveOptimizationSettings', {dispatch});
        };
    },
    afterOptimization() {
        return (dispatch) => {
            dispatch(this.showMessageAboutGeneratedLineupsQuantity());
            // https://abnk.atlassian.net/browse/DFSA-433
            // dispatch(this.tryToResolveOptimizationFailuresIfHappened());
            dispatch(this.createLineupPlayerMap());
            dispatch(this.createLineupTeamCombinationsMap());
            dispatch(this.resolveCorrelationStackCombinations());
            dispatch(this.resolveKeyPlayerStackCombinations());
        };
    },
    beforeResolving(lineupNumber) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            const playerPoints = getPlayerService(sportConfig).exec('prepareRandomPoints', {}, {});

            if (!isEmpty(playerPoints)) {
                dispatch(this.setRandomPoints(lineupNumber, playerPoints));
            }

            const lineupResolver = getLineupResolver(sportConfig);
            const resolvingProcessData = lineupResolver.getResolvingProcessData(getState());

            dispatch(this.setResolvingProcessData(resolvingProcessData));
        };
    },
    runOptimization(constraintsHandler) {
        return (dispatch, getState) => {
            const {lineupGenerator, sportConfig} = getState();
            const {settings} = lineupGenerator;

            dispatch(this.beforeOptimization());

            console.time('ALL TIME');
            if (settings.isBackendGeneratorType(sportConfig)) {
                totalLpSolveExecutionTimeInSeconds = 0;
                dispatch(this.resolveByBackend(constraintsHandler, {version: settings.getGeneratorVersion(sportConfig)}));
            } else {
                LPWorker = null;
                dispatch(this.resolveByFrontend(constraintsHandler));
            }
        };
    },
    resolveByFrontend(constraintsHandler) {
        return (dispatch, getState) => {
            const {settings} = getState().lineupGenerator;

            if (settings.isShowPlayersExposureWhileOptimizedUsed()) {
                dispatch(this.resolveByFrontendFetchingLineupsInSequence(constraintsHandler));
            } else {
                dispatch(this.resolveByFrontendFetchingLineupsWhenOptimized(constraintsHandler));
            }
        };
    },
    resolveByFrontendFetchingLineupsInSequence(constraintsHandler) {
        return (dispatch, getState) => {
            const {lineupsData, lineupsQuantity, sportConfig} = getState();
            const {status, filters: lineupsFilter, rawLineups} = lineupsData;
            const currentLineupNumber = 1 + rawLineups.getQuantity();

            if (status.isFilled) {
                return dispatch(this.afterOptimization());
            }

            dispatch(this.beforeResolving(currentLineupNumber));
            console.log(currentLineupNumber);
            console.time('calculateLineup');
            let LPService = getLpService(sportConfig, {store: null});

            const createdSimplexLineup = dispatch(this.getCreatedSimplexLineup());

            if (createdSimplexLineup !== null) {
                const {lineupResolvingProcess} = getState();
                const simplexLineup = new SimplexLineup(
                    createdSimplexLineup.originalLineup,
                    lineupResolvingProcess.getProcessData(),
                );

                dispatch(this.setRawLineup(simplexLineup));

                const lineup = simplexLineup.getUnits().map((id) => LPService.exec('preparePlayerByLPPlayerId', {id}));

                dispatch(this.fetchLineup(lineup, simplexLineup.getId(), currentLineupNumber));

                constraintsHandler.addLineup(simplexLineup);

                if (currentLineupNumber >= lineupsQuantity.getLineupsQuantity()) {
                    dispatch(this.setStatusOfLineupsIsFilled(true));
                }

                return dispatch(this.resolveByFrontendFetchingLineupsInSequence(constraintsHandler));
            }

            if (null === LPWorker) {
                LPWorker = new Worker(LP_WORKER_URL);

                LPWorker.addEventListener(
                    'message',
                    function (response) {
                        console.log('response', response);
                        const state = getState();
                        const {
                            lineupResolvingProcess,
                            lineupsData: {rawLineups},
                        } = state;
                        const currentLineupNumber = 1 + rawLineups.getQuantity();

                        const simplexLineup = new SimplexLineup(
                            response.data.team,
                            lineupResolvingProcess.getProcessData(),
                        );

                        if (!isLineupValid(simplexLineup, sportConfig)) {
                            const changeable = constraintsHandler.doExecutable(
                                'areConstraintsChangeable',
                                lineupsFilter,
                                false,
                            );
                            if (changeable) {
                                constraintsHandler.setToHandlerStore('denyConstraints', ['exposureMax', 'exposureMin']);
                                dispatch(this.resolveByFrontendFetchingLineupsInSequence(constraintsHandler));
                            } else {
                                if (isThereLineupToReoptimize(state)) {
                                    dispatch(this.setRawLineup(simplexLineup));
                                    dispatch(this.fetchLineup([], simplexLineup.getId(), currentLineupNumber));
                                    return dispatch(
                                        this.resolveByFrontendFetchingLineupsInSequence(constraintsHandler),
                                    );
                                }

                                console.timeEnd('ALL TIME');
                                dispatch(this.setStatusOfLineupsIsFilled(true));
                                dispatch(this.completeFailedOptimizationForMobile());
                            }
                            console.timeEnd('calculateLineup');
                            return dispatch(this.resolveByFrontendFetchingLineupsInSequence(constraintsHandler));
                        }

                        dispatch(this.setRawLineup(simplexLineup));

                        const lineup = simplexLineup
                            .getUnits()
                            .map((id) => LPService.exec('preparePlayerByLPPlayerId', {id}));

                        dispatch(this.fetchLineup(lineup, simplexLineup.getId(), currentLineupNumber));

                        constraintsHandler.addLineup(simplexLineup);
                        constraintsHandler.setToHandlerStore('denyConstraints', []);
                        console.timeEnd('calculateLineup');
                        if (currentLineupNumber >= lineupsQuantity.getLineupsQuantity()) {
                            dispatch(this.setStatusOfLineupsIsFilled(true));
                        }

                        return dispatch(this.resolveByFrontendFetchingLineupsInSequence(constraintsHandler));
                    }.bind(this),
                );
            }

            LPWorker.postMessage({constraints: constraintsHandler.getConstraints()});
        };
    },
    resolveByFrontendFetchingLineupsWhenOptimized(constraintsHandler) {
        return (dispatch, getState) => {
            const {lineupsData, lineupsQuantity, sportConfig} = getState();
            const {status, filters: lineupsFilter, rawLineups} = lineupsData;
            const currentLineupNumber = 1 + rawLineups.getQuantity();

            if (status.isFilled) {
                console.timeEnd('ALL TIME');
                dispatch(this.fetchFrontendLineups(rawLineups.asArr()));

                return dispatch(this.afterOptimization());
            }

            dispatch(this.beforeResolving(currentLineupNumber));
            console.log(currentLineupNumber);
            console.time('calculateLineup');
            const LPService = getLpService(sportConfig);

            const createdSimplexLineup = dispatch(this.getCreatedSimplexLineup());

            if (createdSimplexLineup !== null) {
                const {lineupResolvingProcess} = getState();

                const simplexLineup = new SimplexLineup(
                    createdSimplexLineup.originalLineup,
                    lineupResolvingProcess.getProcessData(),
                );

                dispatch(this.setRawLineup(simplexLineup));

                constraintsHandler.addLineup(simplexLineup);

                if (currentLineupNumber >= lineupsQuantity.getLineupsQuantity()) {
                    dispatch(this.setStatusOfLineupsIsFilled(true));
                }

                return dispatch(this.resolveByFrontendFetchingLineupsWhenOptimized(constraintsHandler));
            }

            if (null === LPWorker) {
                LPWorker = new Worker(LP_WORKER_URL);

                LPWorker.addEventListener(
                    'message',
                    function (response) {
                        console.log('response', response);
                        const state = getState();
                        const {
                            lineupResolvingProcess,
                            lineupsData: {rawLineups},
                        } = state;
                        const generatedLineupsQuantity = rawLineups.getQuantity();

                        const simplexLineup = new SimplexLineup(
                            response.data.team,
                            lineupResolvingProcess.getProcessData(),
                        );

                        if (!isLineupValid(simplexLineup, sportConfig)) {
                            let changeable = constraintsHandler.doExecutable(
                                'areConstraintsChangeable',
                                lineupsFilter,
                                false,
                            );
                            if (changeable) {
                                constraintsHandler.setToHandlerStore('denyConstraints', ['exposureMax', 'exposureMin']);
                            } else {
                                if (isThereLineupToReoptimize(state)) {
                                    dispatch(this.setRawLineup(simplexLineup));
                                    return dispatch(
                                        this.resolveByFrontendFetchingLineupsWhenOptimized(constraintsHandler),
                                    );
                                }

                                dispatch(this.setStatusOfLineupsIsFilled(true));
                                dispatch(this.completeFailedOptimizationForMobile());
                            }
                            console.timeEnd('calculateLineup');
                            return dispatch(this.resolveByFrontendFetchingLineupsWhenOptimized(constraintsHandler));
                        }

                        dispatch(this.setRawLineup(simplexLineup));

                        LPService.exec('handleSettingsBasedOnLineup', {
                            simplexLineup,
                            readyLineupsQuantity: generatedLineupsQuantity,
                            dispatch,
                        });

                        constraintsHandler.addLineup(simplexLineup);
                        constraintsHandler.setToHandlerStore('denyConstraints', []);
                        console.timeEnd('calculateLineup');
                        if (1 + generatedLineupsQuantity >= lineupsQuantity.getLineupsQuantity()) {
                            dispatch(this.setStatusOfLineupsIsFilled(true));
                        }

                        dispatch(this.resolveByFrontendFetchingLineupsWhenOptimized(constraintsHandler));
                    }.bind(this),
                );
            }

            LPWorker.postMessage({constraints: constraintsHandler.getConstraints()});
        };
    },
    resolveByBackend(constraintsHandler, backendParams = {}) {
        return (dispatch, getState) => {
            const {lineupsQuantity, sportConfig, lineupsData} = getState();
            const {status, filters: lineupsFilter, rawLineups} = lineupsData;
            const currentLineupNumber = 1 + rawLineups.getQuantity();

            if (status.isFilled) {
                console.log('totalLpSolveExecutionTimeInSeconds: ', totalLpSolveExecutionTimeInSeconds);
                console.timeEnd('ALL TIME');
                dispatch(this.fetchBackendLineups(rawLineups.asArr()));

                return dispatch(this.afterOptimization());
            }

            dispatch(this.beforeResolving(currentLineupNumber));
            console.log(currentLineupNumber);
            console.time('calculateLineup');

            const createdSimplexLineup = dispatch(this.getCreatedSimplexLineup());

            if (createdSimplexLineup !== null) {
                const {lineupResolvingProcess} = getState();
                const simplexLineup = new SimplexLineup(
                    createdSimplexLineup.originalLineup,
                    lineupResolvingProcess.getProcessData(),
                );

                dispatch(this.setRawLineup(simplexLineup));

                constraintsHandler.addLineup(simplexLineup);

                if (currentLineupNumber >= lineupsQuantity.getLineupsQuantity()) {
                    dispatch(this.setStatusOfLineupsIsFilled(true));
                }

                return dispatch(this.resolveByBackend(constraintsHandler, backendParams));
            }

            const data = {...constraintsHandler.getConstraints(), return_time_usage: true};

            return FetchWrapper.fetchPost(API.toLpSolver(backendParams), {data})
                .then((response) => {
                    console.log('response', {...response});
                    if (!response.success) {
                        dispatch(showPopup('Try to use Browser Side Optimisation'));
                        dispatch({type: Const.OPTIMIZATION_TERMINATE});
                        return;
                    }

                    if ('execution_time_in_seconds' in response.data) {
                        totalLpSolveExecutionTimeInSeconds += Number(response.data.execution_time_in_seconds ?? 0);
                    } else if ('time_usage' in response.data) {
                        totalLpSolveExecutionTimeInSeconds += Number(response.data.time_usage ?? 0);
                    }

                    const state = getState();
                    const {
                        lineupResolvingProcess,
                        lineupsData: {rawLineups},
                    } = state;
                    const generatedLineupsQuantity = rawLineups.getQuantity();

                    const simplexLineup = new SimplexLineup(
                        response.data.result,
                        lineupResolvingProcess.getProcessData(),
                    );

                    if (!isLineupValid(simplexLineup, sportConfig)) {
                        let changeable = constraintsHandler.doExecutable(
                            'areConstraintsChangeable',
                            lineupsFilter,
                            false,
                        );
                        if (changeable) {
                            constraintsHandler.setToHandlerStore('denyConstraints', ['exposureMax', 'exposureMin']);
                        } else {
                            if (isThereLineupToReoptimize(state)) {
                                dispatch(this.setRawLineup(simplexLineup));
                                return dispatch(this.resolveByBackend(constraintsHandler, backendParams));
                            }

                            dispatch(this.setStatusOfLineupsIsFilled(true));
                            dispatch(this.completeFailedOptimizationForMobile());
                        }
                        console.timeEnd('calculateLineup');
                        return dispatch(this.resolveByBackend(constraintsHandler, backendParams));
                    }

                    dispatch(this.setRawLineup(simplexLineup));

                    constraintsHandler.addLineup(simplexLineup);
                    constraintsHandler.setToHandlerStore('denyConstraints', []);
                    console.timeEnd('calculateLineup');
                    if (1 + generatedLineupsQuantity >= lineupsQuantity.getLineupsQuantity()) {
                        dispatch(this.setStatusOfLineupsIsFilled(true));
                    }

                    dispatch(this.resolveByBackend(constraintsHandler, backendParams));
                })
                .catch((error) => {
                    console.error(error);
                    dispatch({type: Const.OPTIMIZATION_TERMINATE});
                });
        };
    },
    getCreatedSimplexLineup() {
        return (dispatch, getState) => {
            const state = getState();
            const {
                sportConfig,
                lineupResolvingProcess,
                lineupsData: {rawLineups},
                lateSwap: {createdLineupsMap, groupSameLineups},
            } = state;

            if (!sportConfig.isModeLateswap() || !groupSameLineups.isUsed()) {
                return null;
            }

            const lineupsStorage = createLineupsStorage(state);

            const lineupView = lineupsStorage.getLateswapLineupViewByEntryId(lineupResolvingProcess.getEntryId());

            if (!lineupView) {
                return null;
            }

            const lineupId = createdLineupsMap.getRegeneratedLineupIdByLateswapLineupPlayersChecksum(
                lineupView.playersChecksum,
            );

            if (!lineupId) {
                return null;
            }

            return rawLineups.getLineup(lineupId);
        };
    },
    showMessageAboutGeneratedLineupsQuantity() {
        return (dispatch, getState) => {
            const {
                lineupsQuantity,
                lineupsData: {rawLineups, lineups},
            } = getState();

            // const generatedLineupsThatHaveUnitsQuantity = rawLineups.getQuantityThatHaveUnits();
            const validLineupsQuantity = lineups.getQuantity();

            if (!validLineupsQuantity) {
                dispatch(showPopup(Const.ZERO_GENERATED_LINEUPS_MESSAGE));
            } else if (validLineupsQuantity < lineupsQuantity.getLineupsQuantity()) {
                dispatch(showPopup('Only ' + validLineupsQuantity + ' Teams Could Be Generated With These Settings'));
            }
        };
    },
    completeFailedOptimizationForMobile() {
        return (dispatch, getState) => {
            if (!UserAgent.isMobile()) {
                return null;
            }

            const {
                lineupsData: {rawLineups},
            } = getState();

            if (rawLineups.getQuantityThatHaveUnits()) {
                return null;
            }

            dispatch(showPopup(Const.ZERO_GENERATED_LINEUPS_MESSAGE));

            dispatch(redirectTo(URL.to('/players')));
        };
    },
};

export default LineupResolver;
